import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import CreditPaymentEditor from './CreditPaymentEditor';

function NewCreditPayment() {
	const navigate = useNavigate();
	const { returnTo } = useEditorReturn();
	const backTo = returnTo || '/AdminScreen/creditPayments';

	return (
		<EntityList>
			<Helmet>
				<title>Agregar Pago</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Pagos', to: '/AdminScreen/creditPayments' },
					{ label: 'Agregar pago' },
				]}
				title='Agregar Pago'
				subtitle='Completá los datos para registrar el pago.'
			/>
			<CreditPaymentEditor
				mode='create'
				onCancel={() => navigate(backTo)}
				onSaved={() => navigate(backTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default NewCreditPayment;
